import { render, staticRenderFns } from "./DrawingCenter.vue?vue&type=template&id=2de40276&scoped=true"
import script from "./DrawingCenter.vue?vue&type=script&lang=js"
export * from "./DrawingCenter.vue?vue&type=script&lang=js"
import style0 from "./DrawingCenter.vue?vue&type=style&index=0&id=2de40276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de40276",
  null
  
)

export default component.exports